"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionGrantsType = void 0;
var OptionGrantsType;
(function (OptionGrantsType) {
    OptionGrantsType["EMPLOYEE"] = "employee";
    OptionGrantsType["NON_EMPLOYEE"] = "non-employee";
})(OptionGrantsType = exports.OptionGrantsType || (exports.OptionGrantsType = {}));
//# sourceMappingURL=OptionGrantType.js.map